import { InjectionToken, Type } from '@angular/core';

export const /** @type {?} */ IMMEDIATE_EFFECTS = new InjectionToken<any[]>(
  'ngrx/effects: Immediate Effects'
);
export const /** @type {?} */ ROOT_EFFECTS = new InjectionToken<Type<any>[]>(
  'ngrx/effects: Root Effects'
);
export const /** @type {?} */ FEATURE_EFFECTS = new InjectionToken<any[][]>(
  'ngrx/effects: Feature Effects'
);
export const /** @type {?} */ CONSOLE = new InjectionToken<Console>('Browser Console');



// WEBPACK FOOTER //
// ../../../modules/effects/src/tokens.ts